<template>
    <span>
        <a
            v-if="row.is_link === 0"
            class="action icon-export"
            title="Download"
            @click.prevent="download()"
        />
        <a
            v-else
            class="action icon-link"
            title="Visit"
            @click.prevent="visitLink()"
        />
        <router-link
            v-if="showDownloads"
            tag="a"
            :to="`/app-repository/${row.id}/downloads`"
            class="edit icon-analytics"
            title="downloads"
        />
    </span>
</template>

<script>
import needsOrganizationSlug from '@/mixins/needsOrganizationSlug'
import canToast from '@/mixins/canToast'

export default {
    components: {},

    mixins: [canToast, needsOrganizationSlug],

    props: {
        row: {
            type: Object,
            required: true,
        },
    },

    data() {
        const { hasPermission } = this.$store.getters
        const showDownloads = hasPermission('create apps')

        return {
            showDownloads,
        }
    },

    methods: {
        download() {
            this.$http
                .get(`${this.organizationSlug}/app-repository/${this.row.id}/download-url`)
                .then(({ data }) => {
                    window.location.href = data.url
                })
                .catch((error) => {
                    const { status } = error.response
                    let message = 'Could not download: '

                    switch (status) {
                        case 403:
                            message += 'You do not have permission'
                            break
                        case 404:
                            message += 'File does not exist'
                            break
                        default:
                            message = 'Opps! Something went wrong'
                            break
                    }

                    this.toast(message, 'error')
                })
        },

        visitLink() {
            this.$http
                .get(`${this.organizationSlug}/app-repository/${this.row.id}/link-url`)
                .then(({ data }) => {
                    window.open(data.url, '_blank')
                })
                .catch((error) => {
                    const { status } = error.response
                    let message = 'Could get link: '

                    switch (status) {
                        case 403:
                            message += 'You do not have permission'
                            break
                        case 404:
                            message += 'Link does not exist'
                            break
                        default:
                            message = 'Opps! Something went wrong'
                            break
                    }

                    this.toast(message, 'error')
                })
        },
    },
}
</script>
